import script from "./CodesPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./CodesPane.vue?vue&type=script&lang=ts&setup=true"

import "./CodesPane.vue?vue&type=style&index=0&id=e7b2a080&lang=scss"

const __exports__ = script;

export default __exports__